import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';

const BASE = '/admin/housing-statuses';

export const housingStatusApi = {
  list: async (params: any) => {
    const res = await apiClient.get(BASE, { params: buildListParams(params) });
    return extractPaginatedData(res);
  },
  getById: async (id: any) => {
    const res = await apiClient.get(`${BASE}/${id}`);
    return res.data?.data;
  },
  create: async (data: any) => {
    const res = await apiClient.post(BASE, data);
    return res.data?.data;
  },
  update: async (id: any, data: any) => {
    const res = await apiClient.patch(`${BASE}/${id}`, data);
    return res.data?.data;
  },
  delete: async (id: any) => {
    const res = await apiClient.delete(`${BASE}/${id}`);
    return res.data;
  },
};
